import { createFileRoute } from "@tanstack/react-router";
import AdminDeliverabilityPage from "@/admin/pages/deliverability";

export const Route = createFileRoute("/admin/deliverability")({
  component: AdminDeliverabilityPage,
});
